function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 0H1C0.4 0 0 0.4 0 1C0 1.6 0.4 2 1 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0Z",
  fill: "#860935"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3 6H0.8C0.3 6 0 6.4 0 7C0 7.6 0.3 8 0.8 8H11.3C11.7 8 12 7.6 12 7C12 6.4 11.7 6 11.3 6Z",
  fill: "#860935"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.1 12H0.9C0.7 12 0.5 12.4 0.5 13C0.5 13.6 0.7 14 0.9 14H7C7.2 14 7.4 13.6 7.4 13C7.4 12.4 7.3 12 7.1 12Z",
  fill: "#860935"
});

function SvgSort({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAwSDFDMC40IDAgMCAwLjQgMCAxQzAgMS42IDAuNCAyIDEgMkgxNUMxNS42IDIgMTYgMS42IDE2IDFDMTYgMC40IDE1LjYgMCAxNSAwWiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjMgNkgwLjhDMC4zIDYgMCA2LjQgMCA3QzAgNy42IDAuMyA4IDAuOCA4SDExLjNDMTEuNyA4IDEyIDcuNiAxMiA3QzEyIDYuNCAxMS43IDYgMTEuMyA2WiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMSAxMkgwLjlDMC43IDEyIDAuNSAxMi40IDAuNSAxM0MwLjUgMTMuNiAwLjcgMTQgMC45IDE0SDdDNy4yIDE0IDcuNCAxMy42IDcuNCAxM0M3LjQgMTIuNCA3LjMgMTIgNy4xIDEyWiIgZmlsbD0iIzg2MDkzNSIvPgo8L3N2Zz4K";
export { SvgSort as ReactComponent };